module.exports = __webpack_public_path__ + "img/home_menu_1_selected.3a028093.png";